/* eslint-disable react/jsx-no-target-blank */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Component } from 'react'
import { Button, Input, Tabs } from 'antd'
import Job from './Job'
import App from './App'
import Trigger from './Trigger'
import * as api from './schedule-api'
// import styled from 'styled-components'
import R from 'ramda'
import { fromNullable } from 'data.maybe'
import { List } from 'immutable-ext'
import Task from 'data.task'
import { ErrorContext } from 'context'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'
import {
  Filler,
  Content,
  Title,
  FullHeightSizer,
  // CriteriaRow,
} from 'core/screen-util'

const jobsTitle = 'Jobs Details'
const settingsTitle = 'Settings'

// const Container = styled.div`
//   padding: 18px;
// `

class Scheduler extends Component {
  constructor(props) {
    super(props)
    const { jobs = [], triggers = [], apps = [] } = this.props
    this.state = {
      jobs,
      triggers,
      apps,
      activeTab: jobsTitle,
      taskFilter: '',
      triggerFilter: '',
      loading: false,
      hideDisabled: false,
    }
    this.retreiveData = this.retreiveData.bind(this)
    this.saveTrigger = this.saveTrigger.bind(this)
    this.saveJob = this.saveJob.bind(this)
    this.saveApp = this.saveApp.bind(this)
    this.success = this.success.bind(this)
  }

  setErr = err => this.setState({ err })

  success(item) {
    return _ => console.log(`${item} has been saved successfully!`)
  }

  toggleHideDisabled = _ =>
    this.setState(({ hideDisabled }) => ({ hideDisabled: !hideDisabled }))

  dataChanged = e => this.setState({ [e.target.name]: e.target.value })

  retreiveData() {
    const { targetInfo } = this.props
    const done = () => this.setState({ loading: false })
    this.setState({ loading: true }, () =>
      List([
        api
          .getJobs(targetInfo)
          .bimap(this.props.setError, jobs => this.setState({ jobs })),
        api
          .getApps(targetInfo)
          .bimap(this.props.setError, apps => this.setState({ apps })),
        api
          .getTriggers(targetInfo)
          .bimap(this.props.setError, triggers => this.setState({ triggers })),
      ])
        .traverse(Task.of, _ => _)
        .fork(done, done)
    )
  }

  saveTrigger(trig) {
    const { targetInfo } = this.props
    const success = savedTriggers => {
      this.setState(({ triggers }) => {
        const newTriggers = savedTriggers.filter(
          t1 => !R.any(t2 => t2.triggerId === t1.triggerId, triggers)
        )

        const updatedTriggers = triggers.map(t1 =>
          fromNullable(
            R.find(t2 => t2.triggerId === t1.triggerId, savedTriggers)
          ).getOrElse(t1)
        )
        const finalTriggers = [...updatedTriggers, ...newTriggers]
        return { triggers: finalTriggers }
      })
    }
    return api
      .saveTriggers(targetInfo)(trig)
      .map(success)
    // .bimap(this.props.setError, success)
  }

  triggerJobs = job => {
    const { targetInfo } = this.props
    return api
      .triggerJobs(targetInfo)(job)
      .fold(this.props.setError, _ => _)
  }

  saveJob(job) {
    const { targetInfo } = this.props
    const success = r => {
      this.setState(({ jobs }) => ({
        jobs: jobs.map(j => {
          if (job.app === j.app && job.jobName === j.jobName) {
            return { ...job, recentRecords: j.recentRecords }
          }
          return j
        }),
      }))

      this.success('job')(r)
    }
    api
      .saveJobs(targetInfo)(job)
      .fork(this.props.setError, success)
  }

  saveApp(app) {
    const { targetInfo, setError } = this.props
    const success = _ => {
      const { apps } = this.state
      const newApps = apps.map(a => (a.appName === app.appName ? app : a))
      this.setState({ apps: newApps })
      this.success('app')(_)
    }

    api
      .saveApps(targetInfo)(app)
      .fork(setError, success)
  }

  componentDidMount() {
    // const { autoRetrieve } = this.props
    // if (autoRetrieve) {
    this.retreiveData()
    // }
  }

  handleItemClick = name => this.setState({ activeTab: name })

  render() {
    const {
      activeTab,
      jobs,
      triggers,
      apps,
      taskFilter,
      triggerFilter,
      loading,
      hideDisabled,
    } = this.state
    // const { screenHeight } = this.props
    // const maxHeight = screenHeight != null ? screenHeight - 280 : 500

    return (
      <FullHeightSizer heightOffset={150} widthOffset={50}>
        {({ height, width }) => (
          <Content style={{ height: height - 10, width }}>
            <Title>Scheduled Jobs</Title>

            <Tabs
              style={{ marginTop: '20px' }}
              type="card"
              activeKey={activeTab}
              onChange={this.handleItemClick}
              tabBarExtraContent={
                <span
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '200px auto 150px',
                    gridColumnGap: '5px',
                  }}
                >
                  {/* no need in gads  <Switch
                checked={hideDisabled}
                onChange={this.toggleHideDisabled}
                checkedChildren="View disabled Jobs"
                unCheckedChildren="Hide disabled Jobs"
              /> */}

                  {activeTab === jobsTitle && (
                    <Input
                      icon="filter"
                      placeholder="Filter Jobs"
                      name="taskFilter"
                      value={taskFilter}
                      onChange={this.dataChanged}
                      defaultValue={false}
                    />
                  )}
                  {activeTab === settingsTitle && (
                    <Input
                      icon="filter"
                      placeholder="Filter Triggers"
                      name="triggerFilter"
                      value={triggerFilter}
                      onChange={this.dataChanged}
                    />
                  )}
                  <Filler />
                  <Button
                    loading={loading}
                    onClick={this.retreiveData}
                    type="primary"
                  >
                    Refresh Data
                  </Button>
                </span>
              }
            >
              <Tabs.TabPane key={jobsTitle} tab={jobsTitle}>
                <Job
                  jobs={jobs}
                  filter={taskFilter}
                  availableTriggers={triggers}
                  hideDisabled={hideDisabled}
                  trigger={this.triggerJobs}
                  save={this.saveJob}
                  error={this.props.error}
                  setError={this.props.setError}
                  height={height}
                />
              </Tabs.TabPane>
              <Tabs.TabPane key={settingsTitle} tab={settingsTitle}>
                <div>
                  <App
                    apps={apps}
                    save={this.saveApp}
                    error={this.props.error}
                    setError={this.props.setError}
                  />
                  <Trigger
                    filter={triggerFilter}
                    triggers={triggers}
                    save={this.saveTrigger}
                    error={this.props.error}
                    setError={this.props.setError}
                    height={height}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
            {activeTab === settingsTitle && (
              <div style={{ marginTop: '10px' }}>
                * Cron expression is a series of characters that provides a
                powerful and flexible way of specifying time schedules. Please{' '}
                <a
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                  href="http://www.quartz-scheduler.org/documentation/quartz-2.3.0/tutorials/crontrigger.html"
                >
                  click here
                </a>
                for detailed documentation.
              </div>
            )}
          </Content>
        )}
      </FullHeightSizer>
    )
  }
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})
const SchedulerConnect = connect(mapStateToProps)(Scheduler)

export default props => (
  <ErrorContext.Consumer>
    {({ error, setError }) => (
      <SchedulerConnect error={error} setError={setError} {...props} />
    )}
  </ErrorContext.Consumer>
)
